import React from 'react';

import { Caption2, Caption3 } from 'components/Common';
import { Logo } from 'components/Common/Logo';
import Spacing from 'components/Common/Spacing';
import { useNavigate } from 'react-router-dom';

import { CompleteTitle, Container, LandingButton, Modal } from './styles';

// 가입(이메일/카카오 공통): 승인 대기 안내 화면.
// 자동 로그인/토큰 저장 없이 로그인 페이지로 보낸다. 승인 전에는 어떤 페이지에도 접근할 수 없다.
// (카카오 소셜 가입도 더 이상 첫 세션 자동 진입을 허용하지 않는다 — 백엔드는 가입 접수 시 refresh 토큰을 회수한다.)
function CompletePage() {
  const navigate = useNavigate();
  return (
    <Container>
      <Modal>
        <Logo />
        <Spacing height={30} />
        <CompleteTitle>가입 신청이 접수되었습니다.</CompleteTitle>
        <Spacing height={10} />
        <Caption2 color="Gray40" style={{ textAlign: 'center' }}>
          관리자 승인 후 로그인할 수 있습니다.
        </Caption2>
        <Caption2 color="Gray40" style={{ textAlign: 'center' }}>
          승인이 완료되면 입력하신 이메일로 안내드릴 예정입니다.
        </Caption2>
        <Spacing height={45} />
        <LandingButton onClick={() => navigate('/login')}>
          <Caption3 color="White">로그인 화면으로</Caption3>
        </LandingButton>
      </Modal>
    </Container>
  );
}

export default CompletePage;
